import { HttpClient } from 'api/HttpClient';

export interface UpdateContractorInformationRequestDto {
  applicationId: string;
  contractorIsLocated: boolean;
  businessName?: string;
  intermediaryId?: string;
  city?: string;
  state?: string;
  contactName?: string;
  contactPhoneNumber?: string;
  contactEmail?: string;
}

export interface ContractorInformationResponseDto {
  contractorIsLocated: boolean | null;
  businessName: string | null;
  city: string | null;
  state: string | null;
  contactName: string | null;
  contactPhoneNumber: string | null;
  contactEmail: string | null;
}

export interface IntermediarySuggestionDto {
  id: string;
  intermediaryName: string;
  intermediaryCity: string | null;
  intermediaryState: string | null;
  intermediaryContacts: IntermediarySuggestionContacts;
}

type IntermediarySuggestionContacts = {
  name: string;
  phone: string | null;
  email: string | null;
}[];

export default class ContractorInformationApi extends HttpClient {
  public constructor() {
    super(process.env.REACT_APP_API_URL + '/prequalification_v2/small-loan-program/contractor-information');
  }

  public async get(applicationId: string): Promise<ContractorInformationResponseDto> {
    return this.instance.get(`?applicationId=${applicationId}`).then((response) => response.data);
  }

  public async update(
    contractorInformation: UpdateContractorInformationRequestDto,
  ): Promise<ContractorInformationResponseDto> {
    return this.instance.put('/', contractorInformation).then((response) => response.data);
  }

  public async getIntermediarySuggestions(name: string): Promise<IntermediarySuggestionDto[]> {
    return this.instance.get(`/intermediaries?name=${encodeURIComponent(name)}`).then((response) => response.data);
  }
}

export const contractorInformationApi = new ContractorInformationApi();
